<template>
  <ion-app>
    <ion-router-outlet />
    <camera-capture />
  </ion-app>
</template>

<script setup lang="ts">
import { watch } from 'vue';
import { IonApp, IonRouterOutlet } from '@ionic/vue';
import { useNetworkStatus } from '@/app/composables/useNetworkStatus';
import { useFolderStore } from '@/app/store/folder-store';
import CameraCapture from '@/app/components/ui/CameraCapture.vue';

const { isOnline } = useNetworkStatus();
const folderStore = useFolderStore();

watch(isOnline, (online, wasOnline) => {
  if (online && wasOnline === false) {
    folderStore.retryPendingFolders();
  }
});
</script>
